import 'signalr'

let hubProxy = null

// 调用服务端写入连接信息
function SendUserLogin(res, name, id) {
  // 这是调用服务端
  res.proxy.invoke('SendUserLogin', name, id).done()
}

const signalrinfo = {}
let conn = {}
function StopHandleCustomerOnDisconnected() {
  if (signalrinfo.conn) {
    signalrinfo.conn.stop()
  }
}
// 总体连接事件
export default function connectServer(mark) {
  return new Promise((resolve, reject) => {
    const apiurl = 'http://47.104.247.47:50000'
    // eslint-disable-next-line no-undef
    signalrinfo.conn = $.hubConnection(apiurl)
    conn = signalrinfo.conn
    conn.qs = {
      mark,
      connectionData: JSON.stringify([{ name: 'myhub' }])
    }
    hubProxy = conn.createHubProxy('myhub')
    conn
      .start()
      .done((res) => {
        console.log(res)
        resolve(conn)
      })
      .fail(() => {
        console.error('通讯连接signalr失败.')
        reject()
      })
    conn.error((error) => {
      console.error(`通讯连接signalr报错:${error}`)
      reject()
    })

    conn.reconnected(() => {
      console.log('通讯重新连接signalr')
      SendUserLogin()
    })

    conn.disconnected(() => {
      console.log('断开了')
    })

    // conn.received((data) => {
    //   console.log(data);
    // });

    conn.connectionSlow(() => {
      StopHandleCustomerOnDisconnected()
    })
  })
}
